import React from "react";

const Phone = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    viewBox="0 0 22.36 22.42"
  >
    <path
      d="M7.26.5H.56S-.56 9.24 6.52 15.8s15.33 6.11 15.33 6.11v-6.38l-6.13-.7-1.86 2.19s-5.8-1.73-8.71-7.8l2.61-2.78L7.26.5z"
      fill="none"
      stroke=""
      strokeMiterlimit="10"
    />
  </svg>
);

export default Phone;
